/**
 * RequireAuth — garde de route.
 *
 * AUTH-02 : pendant le refresh silencieux au démarrage (`bootstrapping = true`),
 * on affiche un spinner plutôt que de rediriger vers /login — évitant la
 * déconnexion apparente au F5/reload.
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.tsx';

export default function RequireAuth({ children }: { children: React.ReactNode }): React.ReactElement {
  const { isAuthenticated, bootstrapping } = useAuth();
  const location = useLocation();

  // Refresh silencieux en cours — attendre avant de juger l'état d'auth.
  if (bootstrapping) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <div className="h-8 w-8 rounded-full border-4 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
